import { render, staticRenderFns } from "./ColumnModal.vue?vue&type=template&id=d963636c"
import script from "./ColumnModal.vue?vue&type=script&lang=js"
export * from "./ColumnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports